@if (loading$ | async) {
  <pr-loader></pr-loader>
}
@if (pledges$ | async; as pledges) {
  <div class="mbl pt">
    <pr-table
      [headerTitle]="'Gestion client - Souscription'"
      [tableData]="table"
      [swiperMinWidth]="992"
      [actionsTemplate]="exampleActionsTemplate"
      (rowClick)="edit($event)"
    >
      @if (canSubscribe$ | async) {
        <pr-button
          size="lg"
          type="button"
          display="neutral"
          tableHeaderRight
          label="  Nouvelle souscription"
          (click)="openBottomSheet()"
        ></pr-button>
      }
      <ng-template #exampleActionsTemplate let-pledge>
        <pr-toolbar clazz="horizontal">
          @if (isPledgeStatusRemovable(pledge)) {
            <pr-button-confirm
              display="danger"
              clazz="pr-toolbar-button last"
              icon="delete_outline"
              title="Suppression"
              comment="Toute suppression est définitive, les données seront perdues."
              labelConfirm="Supprimer"
              labelCancel="Annuler"
              (onConfirm)="delete(pledge)"
              size="sm"
              clazz="pr-toolbar-button last"
              icon="delete_forever"
            >
              Êtes-vous sûr(e) de vouloir supprimer
              <em>“{{ pledge.productType || 'SCPI' }}”</em>
            </pr-button-confirm>
          }
        </pr-toolbar>
      </ng-template>
      <h4 class="semi-bold" emptyTemplate>Aucunes souscriptions</h4>
    </pr-table>
  </div>
}
